<template>
  <div class="rulespage">
    Rules wil go here, but I haven't done this work yet.
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "RulesPage",
  methods: {},
  data() {
    return {};
  },
};
</script>
